import React from "react";
import { WarningOutlined } from "@ant-design/icons";
import { Space, Typography } from "antd";
import { blue } from "@ant-design/colors";

export default function WarningTextStepStart() {
  const { Text } = Typography;

  return (
    <div>
      <div>
        <Typography.Title level={3} strong mark type="danger"
        >
          <Space>
            <WarningOutlined />
            CẢNH BÁO QUAN TRỌNG TRƯỚC KHI CẤP BÙ CHỨNG THƯ SỐ
            <WarningOutlined />
          </Space>
        </Typography.Title>
        <div>
          <Typography.Text className="font-lg">
            Sau khi cấp bù, chứng thư số cũ sẽ bị
            <Typography.Text strong className="font-lg" type="danger">
              {" "}
              thu hồi{" "}
            </Typography.Text>
            và
            <Typography.Text strong className="font-lg" type="danger">
              {" "}
              thay thế{" "}
            </Typography.Text>
            bằng chứng thư số mới. Vì vậy, Quý khách hàng
            <Typography.Text strong className="font-lg" type="danger">
              {" "}
              cần hoàn tất{" "}
            </Typography.Text>
            các việc sau
            <Typography.Text strong className="font-lg" type="danger">
              {" "}
              trước khi bắt đầu{" "}
            </Typography.Text>
            cấp bù:
          </Typography.Text>
        </div>
      </div>

      <Space>
        <Text type="danger" className="visible-hidden">
          <WarningOutlined />
        </Text>
        <Text className="font-lg">
          <div
          // style={{ fontStyle: "italic" }}
          >
            <div></div>
            <ol className="instruction-list font-italic">
              <li>
                <Typography.Text strong className="font-lg" type="danger">
                  Kiểm tra và ký số{" "}
                </Typography.Text>
                các giao dịch điện tử cần thiết: hóa đơn điện tử, tờ khai hải
                quan, hợp đồng điện tử, hồ sơ BHXH điện tử, …
              </li>
              <li>
                <Typography.Text strong className="font-lg" type="danger">
                  Kiểm tra các gói thầu đang tham gia{" "}
                </Typography.Text>
                trên hệ thống Đấu thầu qua mạng. Nếu còn
                <Typography.Text strong className="font-lg">
                  {" "}
                  các gói thầu chưa mở thì nên chờ{" "}
                </Typography.Text>
                để các gói thầu được mở hết rồi mới cấp bù.
              </li>
              <li>
                <Typography.Text strong className="font-lg" type="danger">
                  Kiểm tra và lưu lại toàn bộ mật khẩu đăng nhập{" "}
                </Typography.Text>
                trên các cổng giao dịch điện tử như:
                <Typography.Text strong className="font-lg" type="">
                  {" "}
                  Thuế, Hải quan, Bảo hiểm xã hội{" "}
                </Typography.Text>
                và các hệ thống liên thông khác.
              </li>
            </ol>
            Bằng việc bấm{" "}
            <Typography.Text strong className="font-lg" 
            style={{ color: blue.primary }}
            >
              Xác nhận{" "}
            </Typography.Text>,
            Quý khách đảm bảo đã đọc và hoàn tất các công việc trong cảnh báo quan trọng này để sẵn sàng cấp bù.
          </div>
        </Text>
      </Space>
    </div>
  );
}
